

const Invested = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="52"
      viewBox="0 0 66 52"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.6685 0.219971C41.9492 0.219971 35.7401 2.7777 32.6685 7.89358C29.5969 2.7777 23.3877 0.219971 17.6684 0.219971C7.66188 0.219971 0.168457 6.5039 0.168457 17.0465C0.168457 21.5937 1.99107 27.4995 6.10595 32.402C10.2205 37.3049 12.6682 39.9158 20.6371 45.1914C28.606 50.4673 32.6685 51.3774 32.6685 51.3774C32.6685 51.3774 36.731 50.4673 44.6998 45.1914C52.6686 39.9158 55.1164 37.3049 59.231 32.402C63.3458 27.4995 65.1685 21.5937 65.1685 17.0465C65.1685 6.5039 57.675 0.219971 47.6685 0.219971ZM57.3834 30.9478C53.4985 35.5833 51.281 38.0439 43.389 43.2761C37.5677 47.1359 33.9486 48.5444 32.6683 48.9699C31.3879 48.5443 27.7689 47.1356 21.9475 43.2761C14.0557 38.0439 11.8381 35.5834 7.95312 30.9477C6.2076 28.865 4.79094 26.409 3.85648 23.8447C3.0188 21.5456 2.57581 19.2161 2.57581 17.1081C2.57581 12.713 4.04152 9.03271 6.81438 6.4651C8.13671 5.24065 9.73075 4.28933 11.5528 3.63741C13.4256 2.96707 15.4975 2.62732 17.7111 2.62732C23.2114 2.62732 28.3038 5.19348 30.6847 9.16478L32.6684 12.4734L34.6521 9.16478C37.0331 5.19348 42.1256 2.62732 47.6257 2.62732C49.8393 2.62732 51.9112 2.96707 53.784 3.63727C55.606 4.28933 57.2001 5.24065 58.5224 6.46495C61.2953 9.03271 62.761 12.713 62.761 17.1081C62.761 19.2161 62.318 21.5456 61.48 23.8447C60.5457 26.4088 59.129 28.865 57.3834 30.9478Z"
        fill="#4CAF50"
      />
    </svg>
  );
};

export default Invested;
